module.exports = __webpack_public_path__ + "static/img/img-home-service-03.7a7025f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-service-03.png
// module id = g30O
// module chunks = 1